import type { IconProps } from '@phosphor-icons/react'
import type { ComponentProps, ComponentType, PropsWithChildren } from 'react'

import { cx } from '../../cx'

type ProgressBarProps = PropsWithChildren<{
  type?: 'stacked' | 'inline'
  value: number
  max: number
  className?: string
  Icon?: ComponentType<IconProps>
}>

export function ProgressBar({
  value,
  max,
  className,
  Icon,
  type = 'stacked',
  children,
}: ProgressBarProps) {
  const isStacked = type === 'stacked'

  return (
    <div
      className={cx(
        'flex min-w-60 items-center gap-4 font-base-label',
        { 'flex-col-reverse gap-2 font-base-copy': isStacked },
        className
      )}
    >
      {!isStacked && Icon && <Icon className="size-6 shrink-0" />}

      <progress
        value={value}
        max={max}
        className="h-1 w-full overflow-hidden rounded-lg progress-bar:bg-primary/30 progress-value:bg-primary"
      />

      {children}
    </div>
  )
}

export function ProgressBarLabel({ className, ...props }: ComponentProps<'span'>) {
  return <span className={cx('shrink-0', className)} {...props} />
}
